module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-7-f055f0478409310596d9c3e99f62afc3.jpg";